import React, { useState } from "react";
import styled from "styled-components";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { IoCloudUploadOutline } from "react-icons/io5";
import {
  Text,
  Title,
  Container,
  Main,
} from "../../student/Drawers/studentDrawerKonularim";
import {
  InputText,
  LabelTitle,
  InputSelect,
} from "../../student/studentAyarlar";
import { Form } from "./DrawerSiniflarim";
import { Button } from "../../../components/buttons/Button.styled";

const Icon = styled(IoCloudUploadOutline)`
  width: 100px;
  height: auto;
  color: var(--main-color);
  margin-bottom: 5px;
  cursor: pointer;
`;

const FileName = styled.p`
  font-size: 0.9rem;
  color: gray;
  margin-top: 5px;
  font-style: italic;
`;

const DrawerDokumanEkle = () => {
  const [file, setFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [classValue, setClassValue] = useState("");
  const [unitValue, setUnitValue] = useState("");
  const [tagValue, setTagValue] = useState("");
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [scanResult, setScanResult] = useState(null);
  const [scanLoading, setScanLoading] = useState(false);

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    const allowedTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "image/jpeg",
      "image/png",
    ];

    if (selected) {
      if (!allowedTypes.includes(selected.type)) {
        alert(
          "\u274C Desteklenmeyen dosya t\u00fcr\u00fc! Sadece PDF, Word, Excel, JPG ve PNG y\u00fckleyebilirsiniz."
        );
        e.target.value = null;
        return;
      }

      if (selected.size > 5 * 1024 * 1024) {
        alert("\u274C Dosya boyutu 5MB'den fazla olamaz!");
        e.target.value = null;
        return;
      }

      setFile(selected);
      setSelectedFileName(selected.name);
      setScanResult(null);
    }
  };

  const handleClassChange = (e) => setClassValue(e.target.value);
  const handleUnitChange = (e) => setUnitValue(e.target.value);
  const handleTagChange = (e) => setTagValue(e.target.value);

  const calculateSHA256 = async (file) => {
    const buffer = await file.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  };

  const handleVirusScan = async () => {
    if (!file) return;
    setScanLoading(true);
    const hash = await calculateSHA256(file);

    const response = await fetch(
      `https://www.virustotal.com/api/v3/files/${hash}`,
      {
        headers: {
          "x-apikey":
            "8df47fd19129857b65f381885f4f2f6c6737e00ca89a5cabb076fe5301516651",
        },
      }
    );

    if (response.status === 200) {
      const data = await response.json();
      const maliciousCount = Object.values(
        data.data.attributes.last_analysis_results
      ).filter((r) => r.category === "malicious").length;
      setScanResult({
        allowed: maliciousCount === 0,
        message: `Dosya güvenli yükleyebilirsiniz.`,
      });
    } else {
      setScanResult({
        allowed: true,
        message: "Dosya daha önce taranmamış, ilk yükleme olacak.",
      });
    }
    setScanLoading(false);
  };

  const handleUpload = async () => {
    if (file && classValue && unitValue && tagValue) {
      const storage = getStorage();
      const storageRef = ref(storage, `documents/${file.name}`);
      const metadata = {
        contentType: file.type,
        customMetadata: {
          class: classValue,
          unit: unitValue,
          tag: tagValue,
        },
      };

      try {
        await uploadBytes(storageRef, file, metadata);
        await getDownloadURL(storageRef);
        setUploadSuccess(true);
      } catch (error) {
        console.error("Dosya yüklenirken bir hata oluştu:", error.message);
      }
    } else {
      console.error("Lütfen dosya ve tüm bilgileri doldurun.");
    }
  };

  return (
    <Container style={{ maxWidth: "600px" }}>
      <Title>
        <Text>Doküman Ekleme Bölümü</Text>
      </Title>
      <Main>
        <Form>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <label htmlFor="fileInput">
              <Icon />
            </label>
            <InputText
              type="file"
              id="fileInput"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <LabelTitle>Dosya Yükle</LabelTitle>
            {selectedFileName && (
              <FileName>Seçilen Dosya: {selectedFileName}</FileName>
            )}
          </div>

          <InputSelect value={classValue} onChange={handleClassChange}>
            <option value="">Sınıf Seçiniz</option>
            <option value="class1">Sınıf 1</option>
            <option value="class2">Sınıf 2</option>
          </InputSelect>

          <InputSelect value={unitValue} onChange={handleUnitChange}>
            <option value="">Ünite Seçiniz</option>
            <option value="unit1">Ünite 1</option>
            <option value="unit2">Ünite 2</option>
          </InputSelect>

          <InputText
            type="text"
            placeholder="Etiket Ekleyiniz"
            value={tagValue}
            onChange={handleTagChange}
          />

          <Button
            type="button"
            onClick={handleVirusScan}
            disabled={!file || scanLoading}
          >
            {scanLoading ? "Taranıyor..." : "Virüs Taraması Yap"}
          </Button>

          {scanResult && (
            <p>
              {scanResult.message} <br />
              {scanResult.allowed ? (
                <Button type="button" onClick={handleUpload}>
                  Dosyayı Yükle
                </Button>
              ) : (
                <span style={{ color: "red" }}>
                  ❌ Yüklemeye izin verilmiyor
                </span>
              )}
            </p>
          )}

          {uploadSuccess && <p>✅ Dosya başarıyla yüklendi.</p>}
        </Form>
      </Main>
    </Container>
  );
};

export default DrawerDokumanEkle;
